import { Link } from "react-router-dom";
import { Linkedin, Mail } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_b9a0a9a4-84ed-4294-94dd-1d95262f375b/artifacts/w42uu3e3_Gemini_Generated_Image_md5ockmd5ockmd5o.png";

const navLinks = [
  { name: "Home", path: "/" },
  { name: "Workshops", path: "/workshops" },
  { name: "About", path: "/about" },
  { name: "Contact", path: "/contact" },
];

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer 
      className="bg-[#0A192F] text-white"
      data-testid="footer"
    >
      <div className="container-main py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          {/* Logo & Brand */}
          <div className="lg:col-span-2">
            <Link to="/" data-testid="footer-logo-link" className="inline-block">
              <img
                src={LOGO_URL}
                alt="Be AI Ready - Practical AI Training & Workshops in Australia"
                className="h-12 w-auto mb-5 bg-white p-2 rounded-lg"
                data-testid="footer-logo"
              />
            </Link>
            <p className="text-[#94A3B8] max-w-sm leading-relaxed text-[15px]">
              Practical AI training and workshops helping professionals and businesses 
              use AI confidently, safely, and productively.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-semibold text-base mb-4 font-['Manrope'] text-white">Navigation</h4>
            <nav className="flex flex-col gap-2.5">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className="text-[#94A3B8] hover:text-white transition-colors text-[15px]"
                  data-testid={`footer-nav-${link.name.toLowerCase()}`}
                >
                  {link.name}
                </Link>
              ))}
            </nav>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold text-base mb-4 font-['Manrope'] text-white">Contact</h4>
            <div className="flex flex-col gap-3">
              <a
                href="mailto:info@beaiready.com.au"
                className="flex items-center gap-3 text-[#94A3B8] hover:text-white transition-colors text-[15px]"
                data-testid="footer-email-link"
              >
                <Mail size={16} />
                <span>info@beaiready.com.au</span>
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-[#94A3B8] hover:text-white transition-colors text-[15px]"
                data-testid="footer-linkedin-link"
                aria-label="Connect with Be AI Ready on LinkedIn"
              >
                <Linkedin size={16} />
                <span>LinkedIn</span>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-[#1E3A5F] mt-10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-3">
            <p className="text-[#64748B] text-sm">
              © {currentYear} Be AI Ready. All rights reserved.
            </p>
            <p className="text-[#64748B] text-sm">
              AI Training & Workshops · Australia
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
